import React, { useEffect } from 'react';

const CONTACT_REDIRECT_URL =
  'https://orgfarm-d22a0a94da-dev-ed.develop.my.site.com/SronzerInquiryForm';

const Contact = () => {
  useEffect(() => {
    window.location.replace(CONTACT_REDIRECT_URL);
  }, []);

  // In case redirect is blocked, render nothing.
  return null;
};

export default Contact;

